const FirebaseConfig = {
  apiKey: 'AIzaSyDtyJMwOUCfo6L03x7mybV3Wr9-Rn3bNG8',
  authDomain: 'quotehub-example.firebaseapp.com',
  databaseURL: 'https://quotehub-example.firebaseio.com',
  projectId: 'quotehub-example',
  storageBucket: 'quotehub-example.appspot.com',
  messagingSenderId: '725694882105',
  appId: '1:725694882105:web:a2324f34f13030c6',
};

export default FirebaseConfig;
